<template>
    <div>
        <div class="w" id="content">
            <div class="s_tl">
                当前位置：<a href="/">首页</a>
                <em class="lr3">&#62;</em>
                <a href="/help">帮助中心</a>
                <em class="lr3">&#62;</em>
                <a href="">新手上路</a>
                <em class="lr3">&#62;</em>
                <a href="">常见问题</a>
            </div>
            <div class="ubg">
                <left-side></left-side>
                <!--left over-->
                <div class="u_r">
                    <div class="ah1 alC yahei">
                        <h1 class="f18">常见问题</h1>
                        <p class="c9">发布时间：2022-01-04</p>
                    </div>
                    <div class="ainfo ov yahei">
                        <p>
                            <strong>
                                <span style="font-size:18px;color:#E53333;">一、什么是情趣用品？</span>
                            </strong>
                        </p>
                        <p>
                            <span>夜樱情趣商城对情趣用品的定义是：可以帮助用户起到“增加情趣、减缓焦虑/压力、克服障碍性生理功能”等作用的日常用品。在欧美地区，人们称情趣用品为SexAid，也就是“性爱小帮手”的意思。它对于患有性冷感的女性和功能障碍的男性，或是中年性事不易的夫妇等，都有帮助的作用，更是年轻夫妇枕边的玩具。</span>
                        </p>
                        <p><br></p>
                        <p>
                            <strong>
                                <span style="font-size:18px;color:#E53333;">二、情趣用品的作用</span>
                            </strong>
                        </p>
                        <p>
                            <span>1.性病恐惧者使用成人用品可以释放性欲而不接触异性。</span>
                        </p>
                        <p>
                            <span>2.性欲较强者，性配偶不能满足时，借以释放多余性能量而不搞婚外恋，从而稳定婚姻。</span>
                        </p>
                        <p>
                            <span>3.对男性早泄、女性性冷淡可以用成人用品进行辅助。</span>
                        </p>
                        <p>
                            <span>4.夫妻一方有病或致残、寡居而无法进行性生活者，成人用品是自慰工具。</span>
                        </p>
                        <p>
                            <span>5.夫妻性生活未能尽兴时，可借助成人用品刺激、辅助，达到性高潮。</span>
                        </p>
                        <p>
                            <span>6.有利于提高夫妻性生活质量。性功能较差者可通过成人用品强烈刺激，影响性阈值，达到性高潮，获得性满足。</span>
                        </p>
                        <p>
                            <span>7.成人用品多数都有避孕功能，使用性具可以防止计划外生育，减少超生人口。</span>
                        </p>
                        <p>
                            <span>8.用于单身人士解决生理需求。</span>
                        </p>
                        <p>
                            <span>9.用于有生理功能障碍者的帮助(例如早泄，疲软等)。</span>
                        </p>
                        <p><br></p>
                        <p>
                            <strong><span style="font-size:18px;color:#E53333;">三、如何获得赠品?</span></strong>
                        </p>
                        <p>
                            <span>(1)部分产品自带赠品。</span>
                        </p>
                        <p><br></p>
                        <p>
                            <strong><span style="font-size:18px;color:#E53333;">四、签收商品是需要注意什么?</span></strong>
                        </p>
                        <p>
                            <span>当您在收到货物后，请仔细核对您所订购的商品种类、数量、规格以及相应的赠品，确认无误后，请在送货单上签字，最后付款。</span>
                        </p>
                        <p><br></p>
                        <p>
                            <strong><span style="font-size:18px;color:#E53333;">五、商品质量会有问题吗?如何保障?</span></strong>
                        </p>
                        <p>
                            <span>夜樱情趣商城所出售的产品均通过正规渠道，含有质量保证书的商品按照保证书的承诺执行；夜樱情趣商城对所销售的产品质量做郑重承诺，因产品质量问题，客户可联系我们进行退换货。</span>
                        </p>
                        <p><br></p>
                        <p>
                            <strong><span style="font-size:18px;color:#E53333;">六、可以用那些方式进行付款?</span></strong>
                        </p>
                        <p>
                            <span>夜樱情趣商城提供在线支付(支付宝、微信、余额)。</span>
                        </p>
                    </div>
                    <!--info over-->
                    <p class="lh30">&nbsp;</p>
                    <p class="bline"></p>
                    <p class="lh30">&nbsp;</p>
                    <p style="font-size:16px;">
                        <a href="/help/jifen" style="float:left;">上一篇:会员积分规则</a>
                        <a href="/help/reg" class="pl10" style="float:right;">下一篇:如何注册夜樱情趣商城账号？</a>
                    </p>
                </div>
                <!--right over-->
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Left_side from "@/components/help/left-side"
export default {
    components:{
        'left-side': Left_side
    },
}
</script>

<style scoped>
.ainfo {line-height: 32px;padding-top: 10px;font-size: 14px;}
.ubg{border:1px solid #e5e5e5;background-color:#fff;overflow:hidden;}
.u_l{width:170px;padding:10px;background:#fff;border-right:1px solid #e5e5e5;}
.u_r{padding:10px 40px 30px 40px;border-left:1px solid #e5e5e5;line-height:25px;background:#fff;margin-left:190px;min-height:600px;}
.dsl{display:inline;font-weight:normal;}
.udl{margin:0 5px 15px 5px;}
.udl dt{border-bottom:1px solid #e5e5e5;line-height:40px;display:block;font-size:14px;color:#333;font-weight:bold;margin-bottom:10px;}
.udl dd{line-height:30px;text-indent:15px;}
.udl a{display:block;color:#777;margin-bottom:1px;}
.udl a:hover,.udl a.on{color:#c40000;text-decoration:none; background-color:#e5e1e1;}
.article{width:100%;}
.article li{border-bottom:1px dashed #ddd;display:block;width:100%;font-size:14px;line-height:45px;}
.article a{display:block;width:100%;overflow:hidden;}
.article a:hover{color:#c40000;}
.ah1{color:#333;line-height:30px;padding-bottom:10px;border-bottom:2px solid #ddd;}
.a_goods a{width:220px;height:280px;display:inline;float:left;margin:10px 6px;line-height:18px;white-space:nowrap;overflow:hidden;}
</style>


// WEBPACK FOOTER //
// src/components/help/changjianwenti.vue